import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HasStatusType } from '@app/shared/popup/has-status-type';

@Component({
    templateUrl: './organization-space-move-modal.component.html',
    standalone: false
})
export class OrganizationSpaceMoveModalComponent extends HasStatusType {
  public moveSpaceForm: FormGroup<{ moveChildren: FormControl<boolean> }> = new FormGroup({
    moveChildren: new FormControl(null, Validators.required)
  });

  constructor() {
    const data = inject<{ type: string; }>(MAT_DIALOG_DATA);
    super(data.type);
  }

  /**
   * Get form data to use for moving a Space.
   * @return Move Space form data.
   */
  public getGeneratedObject(): { moveChildren: boolean } {
    return {
      moveChildren: this.moveSpaceForm.controls.moveChildren.value
    };
  }
}
